import { connect } from 'react-redux';

import * as stepOneModule from '../../modules/stepOne';
import * as stepThreeModule from '../../modules/stepThree';
import StepOne from '../../components/StepOne/StepOne';

const mapStateToProps = state => {
  const {
    selectedFirst,
    selectedSecond,
    postalValueFirst,
    postalValueSecond,
    postalCode,
    postalInfo,
  } = state.stepOne;

  return {
    selectedFirst,
    selectedSecond,
    postalValueFirst,
    postalValueSecond,
    postalCode,
    postalInfo,
  };
}

const mapDispatchToProps = dispatch => {
  return {
    dispatchSelectFirst: selected => dispatch(stepOneModule.selectFirst(selected)),
    dispatchSelectSecond: selected => dispatch(stepOneModule.selectSecond(selected)),
    dispatchSetPostalValueFirst: value => dispatch(stepOneModule.setPostalValueFirst(value)),
    dispatchSetPostalValueSecond: value => dispatch(stepOneModule.setPostalValueSecond(value)),
    dispatchSetPostalInfo: postalInfo => dispatch(stepOneModule.setPostalInfo(postalInfo)),
    dispatchSetAreaCode: areaCode => dispatch(stepThreeModule.setAreaCode(areaCode)),
   }
}

export default connect(mapStateToProps, mapDispatchToProps)(StepOne);
